import {connectWebSocket} from "@/api/websocket";

const state = {
}

const mutations = {
}

const actions = {
  connectwebsocket({commit},data){
    return new Promise((resolve, reject) => {
      connectWebSocket().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
